import { render, staticRenderFns } from "./35.vue?vue&type=template&id=b6152a90&scoped=true&"
var script = {}
import style0 from "./35.vue?vue&type=style&index=0&id=b6152a90&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6152a90",
  null
  
)

export default component.exports